import server from './actions.server'
import store from './actions.store'

export default {
    ...server,
    ...store,
}
